module.exports = __webpack_public_path__ + "img/delay.3deb5b06.jpg";